<template>
  <div class="page-outer">
    <div class="page-header page-header-fixed-form">
      <div class="header-left">
        <h1 class="page-title">新增空白活動</h1>
      </div>
      <div class="header-actions">
        <button type="button" class="btn btn-secondary" @click="$router.back()">
          <i class="ri-arrow-left-line"></i>
          返回
        </button>
        <button type="button" class="btn btn-primary" :disabled="submitting" @click="handleSubmit">
          {{ submitting ? '建立中...' : '建立草稿' }}
        </button>
      </div>
    </div>

    <div class="page-container">
    <div class="info-banner">
      <i class="ri-information-line"></i>
      <div class="info-content">
        <strong>空白活動</strong>只建立基本資料，不會預設任何流程步驟。建立後請至編輯器自行新增觸發事件與動作，啟用前至少需要一個完整步驟。若您有常見場景（如歡迎、註冊禮、喚回），建議改用「從劇本建立」會更快。
      </div>
    </div>

    <form class="form-container" @submit.prevent="handleSubmit">
      <div class="form-section">
        <div class="form-group">
          <label class="form-label">活動名稱 <span class="required">*</span></label>
          <input v-model="form.campaignName" type="text" class="form-control" required />
        </div>
        <div class="form-row">
          <div class="form-group">
            <label class="form-label">開始時間</label>
            <input v-model="form.startAt" type="datetime-local" class="form-control" />
          </div>
          <div class="form-group">
            <label class="form-label">結束時間</label>
            <input v-model="form.endAt" type="datetime-local" class="form-control" />
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">活動說明</label>
          <textarea v-model="form.description" class="form-control" rows="3"></textarea>
        </div>
        <div class="form-group">
          <label class="form-label">預算上限（元，選填）</label>
          <input v-model.number="form.budgetCap" type="number" min="0" step="1" class="form-control" />
        </div>
      </div>
    </form>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { marketingCampaignService } from '@/api/modules/marketingCampaigns.js';
import { showError, showSuccess } from '@/utils/swal.js';

function toIsoLocal(value) {
  if (!value) return null;
  return new Date(value).toISOString();
}

export default {
  name: 'CreateMarketingCampaign',
  setup() {
    const router = useRouter();
    const submitting = ref(false);
    const form = ref({
      campaignName: '',
      description: '',
      startAt: '',
      endAt: '',
      budgetCap: null
    });

    const handleSubmit = async () => {
      if (!form.value.campaignName.trim()) {
        showError('請填寫活動名稱');
        return;
      }
      if (form.value.startAt && form.value.endAt && new Date(form.value.startAt) > new Date(form.value.endAt)) {
        showError('開始時間不可晚於結束時間');
        return;
      }

      submitting.value = true;
      try {
        const payload = {
          campaignName: form.value.campaignName.trim(),
          description: form.value.description || null,
          startAt: toIsoLocal(form.value.startAt),
          endAt: toIsoLocal(form.value.endAt),
          budgetCap: form.value.budgetCap ?? null,
          creationSource: 'manual'
        };
        const res = await marketingCampaignService.createCampaign(payload);
        const data = res.data?.data ?? res.data;
        showSuccess('草稿建立成功');
        router.push({ name: 'EditMarketingCampaign', params: { id: data.id } });
      } catch (e) {
        showError(e.response?.data?.message || e.message || '建立失敗');
      } finally {
        submitting.value = false;
      }
    };

    return { form, submitting, handleSubmit };
  }
};
</script>

<style scoped>
@import '~@/assets/scss/components/_list-page-common.scss';
</style>

<style scoped>
.form-container {
  max-width: 720px;
}

.form-section {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.info-banner {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-left: 4px solid #3b82f6;
  border-radius: 6px;
  padding: 14px 16px;
  margin-bottom: 16px;
  font-size: 14px;
  color: #1e40af;
  line-height: 1.6;
  max-width: 720px;
}

.info-banner i {
  font-size: 18px;
  color: #3b82f6;
  flex-shrink: 0;
  margin-top: 1px;
}

.info-content strong {
  font-weight: 600;
}
</style>
